<template>
  <tr>
    <td class="pa-2" style="border: 1px solid #eee">
      <template v-if="!isEdit">{{ item.name }}</template>
      <template v-else>
        <v-text-field v-model="item.name" hide-details outline label="Name"></v-text-field>
      </template>
    </td>
    <td class="pa-2" style="border: 1px solid #eee">
      <template v-if="!isEdit">{{ item.value }}</template>
      <template v-else>
        <v-text-field v-model="item.value" hide-details outline label="Value"></v-text-field>
      </template>
    </td>
    <td class="pa-2" style="border: 1px solid #eee; width: 1%; white-space: nowrap;">
      <v-btn small fab depressed @click="isEdit = true" v-if="!isEdit"><v-icon>edit</v-icon></v-btn>
      <v-btn
        small
        fab
        depressed
        color="success"
        @click="
          isEdit = false
          $emit('save')
        "
        v-else
        ><v-icon>save</v-icon></v-btn
      >
      <v-btn small fab depressed @click="$emit('delete')"><v-icon>delete</v-icon></v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      isEdit: false,
      item: this.value
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytic/EditUser.vue